/**
 * Likőr típusa
 */
export type LiqueurType =
  | 'CREME_DE_XXX'
  | 'CREME_DE_CASSIS'
  | 'GUIGNOLET'
  | 'PUNCH_AU_RUM'
  | 'SLOE_GIN'
  | 'SAMBUCA'
  | 'MARASCHINO_OR_MARRASQUINO_OR_MARASCHINO'
  | 'NOCINO'
  | 'EGGNOG_OR_ADVOCAAT_OR_AVOCAT_OR_ADVOCAT'
  | 'EGG_LIQUEUR'
  | 'OTHER';

export const LiqueurType = {
  CremeDeXxx: 'CREME_DE_XXX' as LiqueurType,
  CremeDeCassis: 'CREME_DE_CASSIS' as LiqueurType,
  Guignolet: 'GUIGNOLET' as LiqueurType,
  PunchAuRum: 'PUNCH_AU_RUM' as LiqueurType,
  SloeGin: 'SLOE_GIN' as LiqueurType,
  Sambuca: 'SAMBUCA' as LiqueurType,
  MaraschinoOrMarrasquinoOrMaraschino:
    'MARASCHINO_OR_MARRASQUINO_OR_MARASCHINO' as LiqueurType,
  Nocino: 'NOCINO' as LiqueurType,
  EggnogOrAdvocaatOrAvocatOrAdvocat:
    'EGGNOG_OR_ADVOCAAT_OR_AVOCAT_OR_ADVOCAT' as LiqueurType,
  EggLiqueur: 'EGG_LIQUEUR' as LiqueurType,
  Other: 'OTHER' as LiqueurType,
};
